import type { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOrderLastSelectedStateListData,
  getOrderLastSelectedStateData,
} from './mockData'
import type { IOrderLastSelectedState } from '~/types/order/models'

interface GetOrderLastSelectedStateListDataResponse {
  data: IOrderLastSelectedState[]
}

async function getOrderLastSelectedListData(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetOrderLastSelectedStateListDataResponse = {
    data: await getOrderLastSelectedStateListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetOrderLastSelectedStateResponse {
  data: IOrderLastSelectedState
}

async function getOrderLastSelectedState(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody: GetOrderLastSelectedStateResponse = {
    data: await getOrderLastSelectedStateData(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postOrderLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOrderLastSelectedStateListData)
}

const patchOrderLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderLastSelectedStateListData)
}

const deleteOrderLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOrderLastSelectedStateListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/orderlastselectedstates',
    handler: getOrderLastSelectedListData,
  },
  {
    method: 'get',
    path: '/api/orderlastselectedstates/:id',
    handler: getOrderLastSelectedState,
  },
  {
    method: 'post',
    path: '/api/orderlastselectedstates',
    handler: postOrderLastSelectedState,
  },
  {
    method: 'patch',
    path: '/api/orderlastselectedstates/:id',
    handler: patchOrderLastSelectedState,
  },
  {
    method: 'delete',
    path: '/api/orderlastselectedstates/:id',
    handler: deleteOrderLastSelectedState,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
